import { render, staticRenderFns } from "./FormExport.vue?vue&type=template&id=481f0cf7&"
import script from "./FormExport.vue?vue&type=script&lang=js&"
export * from "./FormExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports